import { CardsDataSourceBase } from "../../common/CardsDataSourceBase";
import { injectable } from "inversify";
import { injectToken } from "inversify-token";
import { YinzCamAPIResponse } from "yinzcam-api";
import { YinzCamAppServerToken } from "yinzcam-appserver";
import _ from "lodash";

@injectable()
export class YinzCamAppServerTeamPositionFilter extends CardsDataSourceBase {
  public constructor(@injectToken(YinzCamAppServerToken) server) {
    super({ server })
  }

  protected processResponse(response: YinzCamAPIResponse): object | any[] {
    const data = response?.data as any;
    let options = this.getPositionOptions(data);
    return { options };
  }

  getPositionOptions(data: any): any {
    let filter = [].concat(data?.Team?.Filters?.Filter).find(e => e?._attributes?.QueryParameter === 'positionId');
    return [].concat(filter?.FilterItems?.Items).filter(item => item?._attributes?.Id).map(item => {
      let attrs = item?._attributes;
      return {
        title: attrs?.Name,
        value: attrs?.Id
      };
    });
  }
}
